import React, { FormEvent, useContext, useEffect, useState } from 'react';
import serverSideService from '../../../services/server-side-service/server-side-service';
import stars from '../../../assets/stars.svg';
import ownerManualService from '../../services/owner-manual-service/owner-manual-service';

import './owner-manual-ai-search.scss';
import { useHistory } from 'react-router-dom';
import siteMapService from '../../services/site-map-service/site-map-service';
import ServerContext from '../../../contexts/serverContext';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';
interface Props {
    aiSearchContent: OwnerManualProps;
    year?: string;
    model?: string;
}
const OwnerManualAiSearch = (props: Props) => {
    const [error, setError] = useState<string>('');
    const history = useHistory();

    const { aiSearchContent } = props;
    const serverContext = useContext(ServerContext);
    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        const input = document.querySelector(
            '.owner-manual-ai-search-input'
        ) as HTMLInputElement;
        const searchValue = input.value;

        if (searchValue) {
            localStorage.setItem('AI_SEARCH_VALUE', searchValue);
            localStorage.getItem('USER_VIN');

            history.push(
                siteMapService.getPathFromRouterConfigs(
                    serverContext.currentLanguageRegionCode,
                    serverContext.brand,
                    'OwnerManualAiChat',
                    []
                )
            );
        }
    };
    const searchIconFord = './icons/ford-icons/magnifying-glass-preimagine.svg';
    const cancelSearchIconFord = './icons/ford-icons/cancel-search-x.svg';
    const clearText = () => {
        if (serverSideService.isClientSide()) {
            const inputs = document.getElementsByClassName(
                'owner-manual-ai-search-input'
            );
            inputs.length > 0 &&
                Array.from(inputs).forEach(input => {
                    (input as HTMLInputElement).value = '';
                });
        }
    };

    const isAiSearchUp = () =>
        ownerManualService
            .aiSearchHealthCheck()
            .then(response => {
                !response.isAiSearchUp &&
                    setError(aiSearchContent.aiSearchError);
            })
            .catch(error => {
                console.error(error);
            });
    useEffect(() => {
        isAiSearchUp();
    }, []);

    return (
        <div className="om-ai-search-container">
            <div className="om-ai-search-input-container">
                {aiSearchContent.aiSearchTitle && (
                    <h1 className="om-ai-search-title">
                        <img src={stars} aria-hidden="true" />
                        {aiSearchContent.aiSearchTitle}
                    </h1>
                )}
                <div className="om-ai-search-subtitle">
                    {aiSearchContent.aiSearchSubtitle}
                </div>
                <form
                    onSubmit={handleSubmit}
                    data-testid="search-form"
                    role="search"
                    action="."
                    className="search-form"
                >
                    <button
                        aria-label={aiSearchContent.aiSearchButtonAriaLabel}
                        className="search-icons"
                        data-testid={'ai-search-submit-button'}
                        type="submit"
                    >
                        <img
                            loading="lazy"
                            src={searchIconFord}
                            alt="Search Icon"
                        />
                    </button>

                    <input
                        aria-label={aiSearchContent.aiSearchInputAriaLabel}
                        className="owner-manual-ai-search-input"
                        role="searchbox"
                    ></input>
                    <button
                        type="reset"
                        aria-label={
                            aiSearchContent.aiSearchClearButtonArialLabel
                        }
                        data-testid={'clear-ai-search-input-button'}
                        className="search-icons"
                        onClick={clearText}
                    >
                        <img
                            loading="lazy"
                            src={cancelSearchIconFord}
                            alt="cancel search icon"
                        />
                    </button>
                </form>
            </div>
            {error && <div className="om-ai-search-error">{error}</div>}
        </div>
    );
};

export default OwnerManualAiSearch;
